import { subDays, subMonths, subYears } from 'date-fns';

export const ANALYTICS_PRECONFIGURED_TIME_RANGES = [
  { label: 'Last 1 day', value: '1D', getStart: () => subDays(new Date(), 1) },
  { label: 'Last 7 days', value: '7D', getStart: () => subDays(new Date(), 7) },
  {
    label: 'Last month',
    value: '1M',
    getStart: () => subMonths(new Date(), 1),
  },
  { label: 'Last year', value: '1Y', getStart: () => subYears(new Date(), 1) },
];

export const getDefaultDateIndex = (): number => {
  return 1;
};

export const getDefaultDate = () => {
  return ANALYTICS_PRECONFIGURED_TIME_RANGES[getDefaultDateIndex()];
};
